import { tenantAwareApiWrapper, withServiceClient } from './portal-http';
import { trackerClient } from '@terra/shared-rest-clients-tracker';
import type { trackerContract } from '@terra/shared-contracts-tracker';
import type {
  DecodeGrpcHarPreviewBodySchema,
  EncodeGrpcHarPreviewBodySchema,
} from '@terra/shared-contracts-tracker';
import type { z } from 'zod';

export const portalDecodeGrpcHarApi = {
  preview: (payload: z.infer<typeof DecodeGrpcHarPreviewBodySchema>) =>
    tenantAwareApiWrapper<typeof trackerContract.decodeGrpcHarPreview>({
      endpointFn: (headers) =>
        trackerClient.decodeGrpcHarPreview({
          body: payload,
          ...withServiceClient(headers, 'tracker'),
        }),
      useBodyMessage: true,
    }),
  encodePreview: (payload: z.infer<typeof EncodeGrpcHarPreviewBodySchema>) =>
    tenantAwareApiWrapper<typeof trackerContract.encodeGrpcHarPreview>({
      endpointFn: (headers) =>
        trackerClient.encodeGrpcHarPreview({
          body: payload,
          ...withServiceClient(headers, 'tracker'),
        }),
      useBodyMessage: true,
    }),
};
